(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["miravel-solar-live-row"] && !Shopify.designMode) return;
  try {
    (() => {
  const states = new WeakMap();
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('.mv-solar-live-row > summary, .mv-solar-product-faq > details > summary');
    if (!summary || event.defaultPrevented) return;
    const row = summary.parentElement;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      const prior = states.get(row);
      if (prior) { prior.animation.cancel(); states.delete(row); }
      row.style.removeProperty('overflow');
      delete row.dataset.mvExpanded;
      return;
    }
    event.preventDefault();
    const previous = states.get(row);
    const expand = previous ? !previous.expand : !row.open;
    const start = row.getBoundingClientRect().height;
    if (previous) previous.animation.cancel();
    row.open = expand;
    const end = row.getBoundingClientRect().height;
    row.open = true;
    row.dataset.mvExpanded = String(expand);
    row.style.overflow = 'hidden';
    const animation = row.animate([{height:start+'px'},{height:end+'px'}], {
      duration: 280, easing: 'cubic-bezier(.22,1,.36,1)'
    });
    const state = { animation, expand };
    states.set(row, state);
    animation.onfinish = () => {
      if (states.get(row) !== state) return;
      row.open = expand;
      row.style.removeProperty('overflow');
      states.delete(row);
    };
  });
})();
  } catch(e) { console.error(e); }
})();

})();
